import {
  cn,
  formatNumber,
  getColorFromCssVariable,
  HorizontalBarsChart,
} from "ui";
import { ChartCard } from "./ChartCard";
import { useMemo } from "react";
import { HorizontalBarsLoadingSkeleton } from "./HorizontalBarsLoadingSkeleton";
import { useDatadogQuery } from "./useDatadogQuery";

type TopIssuersData = {
  label: string;
  value: number;
}[];

export function TopIssuersChart() {
  const { ref, queryStatus, data, error, refetch } =
    useDatadogQuery<TopIssuersData>({
      chartType: "BIN_TOP_ISSUERS",
      delayMs: 3000,
    });

  const color = getColorFromCssVariable("--chart-categorical-1-subtler");

  const chartData = useMemo(() => {
    if (!Array.isArray(data) || data.length === 0) return [];

    const sortedData = [...data].sort((a, b) => b.value - a.value);
    const total = sortedData.reduce((sum, item) => sum + item.value, 0);

    return sortedData.map((item) => ({
      label: item.label,
      value: item.value,
      percentage: total > 0 ? (item.value / total) * 100 : 0,
      color,
    }));
  }, [data, color]);

  return (
    <ChartCard
      ref={ref}
      title="Top Issuers"
      description="Banks or institutions whose cards are used most frequently."
      contentClassName={cn(
        "overflow-y-auto",
        chartData.length > 0 && "flex-grow"
      )}
      queryStatus={queryStatus}
      loadingSkeleton={<HorizontalBarsLoadingSkeleton />}
      error={error}
      retry={refetch}
    >
      <HorizontalBarsChart
        items={chartData}
        formatValue={(item) =>
          formatNumber({ value: item.value, compact: true })
        }
      />
    </ChartCard>
  );
}
